module.exports = __webpack_public_path__ + "img/Galileo.fe82f2fe.png";